export default __webpack_public_path__ + "static/media/left_chevron.738c6f43.png";